import type { FC } from 'react';

import cn from 'classnames';

interface SkeletonBlockProps {
  className?: string;
}

export const SkeletonBlock: FC<SkeletonBlockProps> = ({ className }) => {
  return <div className={cn('bg-black/[0.07] rounded', className)} />;
};
